import { ReactNode } from "react";

import { Separator } from "@/components/ui/separator";

import { cn } from "@/lib/utils";

export type InfoCardCellProps = {
  title: string;
  value: ReactNode;
  titleClassName?: string;
  valueClassName?: string;
  separatorClassName?: string;
};

export function InfoCardCell({
  title,
  value,
  titleClassName,
  valueClassName,
  separatorClassName,
}: InfoCardCellProps) {
  return (
    <>
      <Separator className={cn("first:hidden", separatorClassName)} />
      <div className="flex flex-row grow items-center justify-between py-2 lg:py-0">
        <div
          className={cn(
            "text-sm font-semibold text-muted-foreground text-ellipsis",
            titleClassName
          )}
        >
          {title}
        </div>
        {value && (
          <div
            className={cn("text-sm font-bold text-ellipsis", valueClassName)}
          >
            {value}
          </div>
        )}
      </div>
    </>
  );
}
